/* eslint-disable react/no-danger */
import React from 'react';
import { isEmpty, map } from 'lodash';
import { Link } from 'gatsby';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';

export default function FreeZoneTextContentWithThreeColumnCard({ id, data, dir }) {
  const { title, text, items, link } = data;
  return (
    <section id={id} className="py-[50px] md:py-[100px] bg-white overflow-hidden">
      <BoxedContainer className="flex flex-col gap-y-10 md:gap-y-[52px]">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-7 lg:gap-y-[30px]">
          <div className="flex flex-col gap-y-7 md:gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-[#231F20]
            h2-child:leading-1.2  text-center h2-child:!m-0 md:!text-center ltr:text-left
            rtl:text-right"
            />
            <div className="h-[2px] w-[70px] bg-[#CE445B] md:mx-auto" />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#4D4D4D] p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular p-child:rtl:font-GESSTwoDWTCLight
            md:!text-center ltr:text-left rtl:text-right"
          />
        </motion.div>
        {isEmpty(items) || (
          <div className="flex flex-col md:flex-row gap-10 md:gap-[30px]">
            {map(items, (item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3 * (index + 1) }}
                className="w-full md:w-[33.3333%] flex flex-col gap-y-5 md:gap-y-7">
                {isEmpty(item.content.image) || (
                  <LazyLoadImage
                    src={item.content.image.url}
                    alt={title}
                    className="w-full h-full hidden md:block max-h-[200px] md:h-[472px] md:max-h-[472px] object-cover"
                  />
                )}
                {!isEmpty(item.content.mobileImage) ? (
                  <LazyLoadImage
                    src={item.content.mobileImage.url}
                    alt={title}
                    className="w-full h-full block md:hidden max-h-[200px] md:max-h-[472px] object-cover"
                  />
                ) : (
                  isEmpty(item.content.image) || (
                    <LazyLoadImage
                      src={item.content.image.url}
                      alt={title}
                      className="w-full h-full md:hidden max-h-[200px] md:max-h-[472px] object-cover"
                    />
                  )
                )}
                <div className="flex flex-col gap-y-[22px] lg:gap-y-[13px]">
                  <h4
                    className="text-clamp18to25 ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium leading-1
                  text-[#58595B]">
                    {item.content.imageCardTitle}
                  </h4>
                  <div
                    dangerouslySetInnerHTML={{ __html: item.content.imageCardText }}
                    className="p-child:text-[#4D4D4D] p-child:text-clamp12to18 p-child:font-normal
                  p-child:leading-[1.4] p-child:md:leading-[1.4] 
                  p-child:mb-0 p-child:ltr:font-URWDINRegular 
                  p-child:rtl:font-GESSTwoDWTCLight"
                  />
                </div>
              </motion.div>
            ))}
          </div>
        )}
        {isEmpty(link) || (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.7 }}
            viewport={{ once: true }}
            className="flex justify-center pt-2">
            <Link
              href={link.url}
              className="w-fit flex justify-center items-center rounded-[48px]
                bg-[#CE445B] hover:bg-[#B53B50] text-white uppercase 
                ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium 
                ltr:tracking-[0.96px] leading-1.5 md:leading-1.25
                  min-h-[40px] md:h-[51px] text-center px-12 md:px-14 py-2
                  rtl:text-[12px] ltr:text-[11px] rtl:md:text-[16px] ltr:md:text-[15px] 
                  rtl:lg:text-[18px]
                  md:py-5 rtl:pt-[10px] ltr:pt-[12px] ltr:md:pt-6 rtl:md:pt-5"
              dir={dir}>
              {link.name}
            </Link>
          </motion.div>
        )}
      </BoxedContainer>
    </section>
  );
}
